var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"no-results",class:{ '-dark': _vm.isDarkMode }},[_c('img',{staticClass:"no-results__image",attrs:{"src":_vm.path,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"no-results__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }